import React from "react";
import moment from "moment";
import { Row, Col } from "antd";
import { CREDIT_TYPES } from "utils/constants";
import { useTranslation } from "react-i18next";
import {
  CardContainer,
  CardTitle,
  CardTitleText,
  CardBody,
  CreditAmountBigText,
  ExpireText,
} from "./styles";

type Credit = {
  id: number;
  originalAmount: number;
  remainingAmount: number;
  creditType: string;
  expiredAt: string;
};

type CreditListProps = {
  credits: Credit[];
};

const CreditList = ({ credits }: CreditListProps) => {
  const { t } = useTranslation("my_credits");

  const renderCreditOriginalAmount = (credit: Credit) =>
    credit.creditType === CREDIT_TYPES.SUBSCRIPTION
      ? `${credit.originalAmount} ${t("credits/month")}`
      : `${credit.originalAmount} ${t("credits")}`;

  const renderCreditName = (credit: Credit) => {
    switch (credit.creditType) {
      case CREDIT_TYPES.SUBSCRIPTION:
        return t("Subscription");
      case CREDIT_TYPES.MANUAL:
        return t("Extra Credits");
      case CREDIT_TYPES.FREE_TRIAL:
        return t("Free Trial");
      case CREDIT_TYPES.TEACHER_MISSED:
        return t("Teacher Missed");
      case CREDIT_TYPES.NO_TEACHER_SIGNED_UP:
        return t("No Teacher Signed Up");
      case CREDIT_TYPES.FULL_COURSE:
        return t("Full Course");
      case CREDIT_TYPES.SUPPORT_CREDIT:
        return t("Support Credit");
      case CREDIT_TYPES.PARTNER_CREDIT:
        return t("Partner Credit");
      case CREDIT_TYPES.STAFF_CREDIT:
        return t("Staff Credit");
      default:
        return "";
    }
  };

  return (
    <Row gutter={[16, 16]}>
      {credits.map((credit: Credit) => (
        <Col
          lg={6}
          md={8}
          sm={12}
          xs={24}
          key={credit.id}
          style={{ width: "100%" }}
        >
          <CardContainer>
            <CardTitle style={{ flexWrap: "wrap" }}>
              <CardTitleText>{renderCreditName(credit)}</CardTitleText>
              <CardTitleText>
                {renderCreditOriginalAmount(credit)}
              </CardTitleText>
            </CardTitle>

            <CardBody>
              <span style={{ color: "#282828" }}>
                {t("Remaining credits")}{" "}
              </span>
              <CreditAmountBigText>
                {credit.remainingAmount}
              </CreditAmountBigText>
              <ExpireText>
                {t("Expires")}{" "}
                {moment(credit.expiredAt, "YYYY-MM-DD hh:mm:ss UTC").format(
                  "ll"
                )}
              </ExpireText>
            </CardBody>
          </CardContainer>
        </Col>
      ))}
    </Row>
  );
};

export default CreditList;
